import React, { useState } from 'react';
import heroImage from '../assets/hero.webp';
import wheatSeed from '../assets/hero.webp';
import riceSeed from '../assets/hero1.webp';
import cornSeed from '../assets/hero.webp';
import seed1 from '../assets/seed1.webp';
import seed2 from '../assets/seed2.webp';
import seed3 from '../assets/seed3.webp';





const SeedInformation = () => {
  const [activeFaq, setActiveFaq] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedSeason, setSelectedSeason] = useState('');

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  const handleDistrictChange = (e) => {
    setSelectedDistrict(e.target.value);
  };

  const handleSeasonChange = (e) => {
    setSelectedSeason(e.target.value);
  };

  return (
    <div className="bg-gray-50 min-h-screen" style={{ marginTop: '80px' }}>
      {/* Hero Section */}
      <div
        className="relative h-96 bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            बेहतर उत्पादन के लिए बीजों का सही चुनाव और उपयोग
          </h1>
          <p className="text-xl text-white">किसान भाइयों के लिए संपूर्ण बीज जानकारी</p>
          <div className="mt-6">

          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        {/* Introduction - Enhanced */}
        <div className="bg-white rounded-lg shadow-xl p-8 mb-12 transform hover:scale-[1.01] transition duration-500 hover:shadow-2xl">
          <h2 className="text-3xl font-bold text-green-800 mb-4">बीज जानकारी: कृषि सफलता की पहली सीढ़ी</h2>
          <p className="text-lg text-gray-700 mb-4">
            उत्तम फसल उत्पादन के लिए गुणवत्तापूर्ण बीजों का चयन, सही उपयोग और उचित संरक्षण अत्यंत आवश्यक है। एक अच्छा बीज फसल उत्पादन की नींव होता है जो 20-25% तक उत्पादन बढ़ा सकता है। भारतीय कृषि अनुसंधान परिषद (ICAR) के अनुसार, प्रमाणित बीजों के उपयोग से किसानों को 15-20% अधिक उपज प्राप्त होती है। यहाँ हम आपको विभिन्न फसलों के उन्नत बीजों, उनके उपयोग की विधि और संरक्षण तकनीकों के बारे में विस्तृत जानकारी प्रदान कर रहे हैं।
          </p>

          <div className="grid md:grid-cols-3 gap-6 mt-6">
            <div className="bg-green-50 p-4 rounded-lg border border-green-200">
              <h3 className="font-bold text-green-700 mb-2">बीज का महत्व</h3>
              <p className="text-sm text-gray-700">
                बीज फसल उत्पादन का प्राथमिक निवेश है। अच्छे बीज में 85-90% अंकुरण क्षमता, उच्च शुद्धता, रोग प्रतिरोधक क्षमता और अनुकूलित वृद्धि गुण होने चाहिए।
              </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
              <h3 className="font-bold text-blue-700 mb-2">बीज प्रकार</h3>
              <p className="text-sm text-gray-700">
                मुख्यतः चार प्रकार: फाउंडेशन (नीला टैग), रजिस्टर्ड (सफेद टैग), प्रमाणित (बैंगनी टैग) और ब्रांडेड बीज। प्रत्येक का अपना विशेष उपयोग है।
              </p>
            </div>
            <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
              <h3 className="font-bold text-yellow-700 mb-2">चयन मापदंड</h3>
              <p className="text-sm text-gray-700">
                बीज चुनते समय जलवायु अनुकूलन, मिट्टी प्रकार, रोग प्रतिरोधक क्षमता, उपज क्षमता और बाजार मांग को ध्यान में रखें।
              </p>
            </div>
          </div>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mt-6">
            <p className="text-yellow-700 font-medium">
              💡 महत्वपूर्ण: भारत में किसानों को प्रमाणित बीजों का उपयोग करने से 15-20% अधिक उपज मिलती है। हमेशा प्रमाणित स्रोतों से ही बीज खरीदें। नकली या निम्न गुणवत्ता वाले बीजों से न केवल उपज कम होती है बल्कि रोगों का खतरा भी बढ़ जाता है।
            </p>
          </div>
           <audio controls className="mb-6">
                      <source src="/audio/seedinfo.mp3" type="audio/mp3" />

                   आपका ब्राउज़र ऑडियो को सपोर्ट नहीं करता।
                   </audio> 
        </div>

        {/* Seed Certification - Enhanced */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-12 transform hover:-translate-y-1 transition duration-300">
          <h2 className="text-3xl font-bold text-center mb-6 bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
            बीज प्रमाणन प्रक्रिया (Seed Certification Process)
          </h2>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-purple-50 p-6 rounded-lg border border-purple-200 hover:bg-purple-100 transition duration-300">
              <h3 className="text-xl font-semibold text-purple-700 mb-3 flex items-center">
                <span className="bg-purple-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3">1</span>
                फाउंडेशन सीड
              </h3>
              <p className="text-gray-700">
                यह सबसे शुद्ध बीज होता है जिसे ICAR या राज्य कृषि विश्वविद्यालय द्वारा विकसित किया जाता है। इन बीजों पर नीले रंग का टैग लगा होता है। इन बीजों का उत्पादन मूल बीज उत्पादकों द्वारा किया जाता है जिन्हें भारत सरकार द्वारा मान्यता प्राप्त होती है। फाउंडेशन बीजों की शुद्धता 99% से अधिक होनी चाहिए और अंकुरण क्षमता न्यूनतम 85% होती है।
              </p>
            </div>

            <div className="bg-purple-50 p-6 rounded-lg border border-purple-200 hover:bg-purple-100 transition duration-300">
              <h3 className="text-xl font-semibold text-purple-700 mb-3 flex items-center">
                <span className="bg-purple-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3">2</span>
                रजिस्टर्ड सीड
              </h3>
              <p className="text-gray-700">
                फाउंडेशन सीड से उत्पादित बीज जिस पर सफेद रंग का टैग लगा होता है। यह बीज उत्पादकों द्वारा तैयार किए जाते हैं। रजिस्टर्ड बीजों की शुद्धता 98% से कम नहीं होनी चाहिए और अंकुरण क्षमता कम से कम 85% होती है। ये बीज राज्य बीज प्रमाणन एजेंसियों द्वारा प्रमाणित किए जाते हैं और प्रमाणित बीज उत्पादन के लिए उपयोग किए जाते हैं।
              </p>
            </div>

            <div className="bg-purple-50 p-6 rounded-lg border border-purple-200 hover:bg-purple-100 transition duration-300">
              <h3 className="text-xl font-semibold text-purple-700 mb-3 flex items-center">
                <span className="bg-purple-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3">3</span>
                प्रमाणित बीज
              </h3>
              <p className="text-gray-700">
                रजिस्टर्ड सीड से उत्पादित बीज जिस पर बैंगनी रंग का टैग लगा होता है। यह बीज किसानों को बेचे जाते हैं और सबसे ज्यादा उपयोग किए जाते हैं। प्रमाणित बीजों की शुद्धता 98% और अंकुरण क्षमता 85% से कम नहीं होनी चाहिए। ये बीज भारतीय बीज अधिनियम, 1966 के तहत निर्धारित मानकों को पूरा करते हैं और किसानों के लिए सबसे उपयुक्त माने जाते हैं।
              </p>
            </div>
          </div>

          <div className="mt-8 bg-blue-50 p-6 rounded-lg border border-blue-200">
            <h3 className="text-xl font-semibold text-blue-700 mb-3">बीज प्रमाणन के लाभ:</h3>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <li className="flex items-start">
                <span className="bg-blue-600 text-white rounded-full w-5 h-5 flex items-center justify-center mr-2 mt-1 flex-shrink-0">✓</span>
                <span><strong>अधिक अंकुरण प्रतिशत (85-90%)</strong> - प्रमाणित बीजों में अंकुरण क्षमता अधिक होती है जिससे बुवाई में कम बीज लगता है और पौधों की संख्या अधिक होती है।</span>
              </li>
              <li className="flex items-start">
                <span className="bg-blue-600 text-white rounded-full w-5 h-5 flex items-center justify-center mr-2 mt-1 flex-shrink-0">✓</span>
                <span><strong>रोग मुक्त बीज</strong> - प्रमाणित बीजों को विभिन्न रोगों से मुक्त रखने के लिए उपचारित किया जाता है, जिससे फसल को प्रारंभिक अवस्था में ही सुरक्षा मिल जाती है।</span>
              </li>
              <li className="flex items-start">
                <span className="bg-blue-600 text-white rounded-full w-5 h-5 flex items-center justify-center mr-2 mt-1 flex-shrink-0">✓</span>
                <span><strong>उच्च गुणवत्ता और शुद्धता</strong> - इन बीजों में अन्य फसलों के बीज, खरपतवार के बीज या अशुद्धियाँ नहीं होतीं, जिससे फसल की एकरूपता बनी रहती है।</span>
              </li>
              <li className="flex items-start">
                <span className="bg-blue-600 text-white rounded-full w-5 h-5 flex items-center justify-center mr-2 mt-1 flex-shrink-0">✓</span>
                <span><strong>बेहतर उपज क्षमता</strong> - प्रमाणित बीजों से 15-25% तक अधिक उपज प्राप्त होती है क्योंकि ये उन्नत किस्मों के होते हैं और इनमें उच्च उत्पादन क्षमता होती है।</span>
              </li>
            </ul>
          </div>

          <div className="mt-6 bg-green-50 p-4 rounded-lg border-l-4 border-green-400">
            <h4 className="font-bold text-green-800 mb-2">प्रमाणित बीज कहाँ से प्राप्त करें?</h4>
            <p className="text-gray-700">
              प्रमाणित बीज आप निम्न स्थानों से प्राप्त कर सकते हैं:
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>राज्य बीज निगम की आधिकारिक दुकानें</li>
                <li>कृषि विज्ञान केंद्र (KVK)</li>
                <li>मान्यता प्राप्त बीज विक्रेता</li>
                <li>सरकारी बीज वितरण केंद्र</li>
                <li>कृषि विश्वविद्यालयों के बीज उत्पादन इकाई</li>
              </ul>
              बीज खरीदते समय हमेशा बीज टैग और बिल की जाँच अवश्य करें।
            </p>
          </div>
        </div>

        {/* Seed Varieties Section - Enhanced */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-center mb-8 bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
            उत्तम किस्मों के बीज (Top Recommended Varieties)
          </h2>

          <div className="grid md:grid-cols-3 gap-6">
            {/* Wheat - Enhanced */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition duration-300 transform hover:-translate-y-2">
              <img
                src={seed1}
                alt="गेहूं"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-2xl font-bold text-green-700 mb-3">🔹 गेहूं:</h3>
                <p className="text-gray-600 mb-3">भारत की प्रमुख रबी फसल जो देश के 30 मिलियन हेक्टेयर से अधिक क्षेत्र में उगाई जाती है। उत्तर प्रदेश, पंजाब और हरियाणा प्रमुख उत्पादक राज्य हैं।</p>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>HD-2967</strong> — उच्च उत्पादन क्षमता (60-65 क्विंटल/एकड़), पीला कंडुआ रोधी, 130-135 दिन में पकने वाली, उत्तर भारत के लिए उपयुक्त। इस किस्म में प्रोटीन की मात्रा 11-12% होती है।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>PBW-725</strong> — रोग प्रतिरोधक किस्म, 130-135 दिन में पकने वाली, 55-60 क्विंटल/एकड़ उपज देती है। यह किस्म पीला कंडुआ और लीफ रस्ट के प्रति सहनशील है।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>DBW-303</strong> — प्रोटीन युक्त (12-13%), उत्तर भारत के लिए उपयुक्त, 125-130 दिन में पकने वाली, 50-55 क्विंटल/एकड़ उपज। यह किस्म बौनी प्रजाति है जिसमें गिरने की समस्या नहीं होती।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>HI-1544</strong> — सूखा सहनशील किस्म, कम पानी वाले क्षेत्रों के लिए उपयुक्त, 45-50 क्विंटल/एकड़ उपज। यह किस्म मध्य भारत के लिए विशेष रूप से विकसित की गई है।</span>
                  </li>
                </ul>
                <div className="mt-4 text-sm text-gray-500 bg-gray-50 p-3 rounded-lg">
                  <p><strong>बुवाई समय:</strong> नवंबर का पहला पखवाड़ा (उत्तरी भारत), नवंबर का दूसरा पखवाड़ा (मध्य भारत)</p>
                  <p><strong>बीज दर:</strong> 40-45 किलो/एकड़ (ड्रिल विधि), 50-55 किलो/एकड़ (छिड़काव विधि)</p>
                  <p><strong>उर्वरक:</strong> 120:60:40 किग्रा NPK/हेक्टेयर + 25 किग्रा जिंक सल्फेट (जिंक की कमी वाले क्षेत्रों में)</p>
                </div>
              </div>
            </div>

            {/* Rice - Enhanced */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition duration-300 transform hover:-translate-y-2">
              <img
                src={seed2}
                alt="धान"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-2xl font-bold text-green-700 mb-3">🔹 धान:</h3>
                <p className="text-gray-600 mb-3">भारत की प्रमुख खरीफ फसल जो देश के 44 मिलियन हेक्टेयर से अधिक क्षेत्र में उगाई जाती है। पश्चिम बंगाल, उत्तर प्रदेश और पंजाब प्रमुख उत्पादक राज्य हैं।</p>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>Pusa Basmati 1121</strong> — खुशबूदार, निर्यात योग्य (135-140 दिन), 22-25 क्विंटल/एकड़, सुगंधित दाने जिनकी लंबाई पकने के बाद दोगुनी हो जाती है। यह किस्म विशेष रूप से निर्यात के लिए उगाई जाती है।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>MTU-1010</strong> — मध्यम अवधि (125-130 दिन), 28-32 क्विंटल/एकड़ उपज, तना छेदक कीट के प्रति सहनशील। यह किस्म तेलंगाना और आंध्र प्रदेश में बहुत लोकप्रिय है।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>DRR Dhan 44</strong> — सूखा सहनशील, कम पानी वाले क्षेत्रों के लिए उपयुक्त, 20-22 क्विंटल/एकड़ उपज। यह किस्म 30-40% कम पानी में भी अच्छी उपज देती है।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>Swarna Sub-1</strong> — बाढ़ सहनशील किस्म, 14-15 दिन तक पानी में डूबे रहने पर भी जीवित रह सकती है, 25-28 क्विंटल/एकड़ उपज। यह किस्म बिहार और पूर्वी उत्तर प्रदेश के लिए आदर्श है।</span>
                  </li>
                </ul>
                <div className="mt-4 text-sm text-gray-500 bg-gray-50 p-3 rounded-lg">
                  <p><strong>बुवाई समय:</strong> जून-जुलाई (खरीफ), नवंबर-दिसंबर (रबी - दक्षिण भारत में)</p>
                  <p><strong>बीज दर:</strong> 8-10 किलो/एकड़ (प्रत्यक्ष बुवाई), 4-5 किलो/एकड़ (नर्सरी के लिए)</p>
                  <p><strong>उर्वरक:</strong> 100:50:50 किग्रा NPK/हेक्टेयर + 25 किग्रा जिंक सल्फेट (जिंक की कमी वाले क्षेत्रों में)</p>
                </div>
              </div>
            </div>

            {/* Corn - Enhanced */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition duration-300 transform hover:-translate-y-2">
              <img
                src={seed3}
                alt="मक्का"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-2xl font-bold text-green-700 mb-3">🔹 मक्का:</h3>
                <p className="text-gray-600 mb-3">भारत की प्रमुख खरीफ फसल जिसका उपयोग मानव आहार, पशु आहार और औद्योगिक उपयोग के लिए किया जाता है। कर्नाटक, मध्य प्रदेश और महाराष्ट्र प्रमुख उत्पादक राज्य हैं।</p>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>HQPM1</strong> — हाई प्रोटीन हाइब्रिड (10.5% प्रोटीन), 25-30 क्विंटल/एकड़, 90-95 दिन में पकने वाली। यह किस्म क्वालिटी प्रोटीन मेज (QPM) प्रकार की है जिसमें लाइसिन और ट्रिप्टोफैन अमीनो एसिड अधिक मात्रा में होते हैं।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>Bio9637</strong> — कीट रोधी, उच्च उपज (30-35 क्विंटल), 90-95 दिन में पकने वाली। यह किस्म स्टेम बोरर और अमेरिकन बोलवर्म के प्रति प्रतिरोधी है।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>Pusa Hybrid Makka 5</strong> — बौनी किस्म, तूफान प्रतिरोधी, 28-32 क्विंटल उपज, 85-90 दिन में पकने वाली। यह किस्म उत्तर भारत के लिए विशेष रूप से विकसित की गई है।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>DHM-117</strong> — द्वि-उपयोगी किस्म (दाना और हरा चारा दोनों के लिए), 35-40 क्विंटल/एकड़ दाना उपज, 250-300 क्विंटल/एकड़ हरा चारा। यह किस्म डेयरी फार्मिंग वाले क्षेत्रों के लिए आदर्श है।</span>
                  </li>
                </ul>
                <div className="mt-4 text-sm text-gray-500 bg-gray-50 p-3 rounded-lg">
                  <p><strong>बुवाई समय:</strong> जून-जुलाई (खरीफ), अक्टूबर-नवंबर (रबी - दक्षिण भारत में)</p>
                  <p><strong>बीज दर:</strong> 8-10 किलो/एकड़ (संकर किस्म), 12-15 किलो/एकड़ (सामान्य किस्म)</p>
                  <p><strong>उर्वरक:</strong> 120:60:40 किग्रा NPK/हेक्टेयर + 25 किग्रा जिंक सल्फेट (जिंक की कमी वाले क्षेत्रों में)</p>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Crops - Expanded */}
          <div className="grid md:grid-cols-3 gap-6 mt-6">
            {/* Mustard */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="p-6">
                <h3 className="text-2xl font-bold text-green-700 mb-3">🔹 सरसों:</h3>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>RH-749</strong> — उच्च तेल सामग्री (42-44%), 18-20 क्विंटल/एकड़, 125-130 दिन में पकने वाली। यह किस्म सफेद रस्ट और अल्टरनेरिया ब्लाइट के प्रति सहनशील है।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>NRCHB-506</strong> — संकर किस्म, 22-25 क्विंटल/एकड़, तेल सामग्री 38-40%, एफिड प्रतिरोधी। यह किस्म राजस्थान और हरियाणा के लिए उपयुक्त है।</span>
                  </li>
                </ul>
                <div className="mt-4 text-sm text-gray-500">
                  <p><strong>बुवाई समय:</strong> अक्टूबर का दूसरा पखवाड़ा</p>
                  <p><strong>बीज दर:</strong> 2-3 किलो/एकड़</p>
                </div>
              </div>
            </div>

            {/* Chickpea */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="p-6">
                <h3 className="text-2xl font-bold text-green-700 mb-3">🔹 चना:</h3>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>Pusa-372</strong> — काबुली चना, 18-20 क्विंटल/एकड़, विल्ट और बोट्राइटिस रोग प्रतिरोधी। यह किस्म मध्य और उत्तर भारत के लिए उपयुक्त है।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>JG-11</strong> — देसी चना, 12-15 क्विंटल/एकड़, सूखा सहनशील। यह किस्म महाराष्ट्र और मध्य प्रदेश में बहुत लोकप्रिय है।</span>
                  </li>
                </ul>
                <div className="mt-4 text-sm text-gray-500">
                  <p><strong>बुवाई समय:</strong> अक्टूबर-नवंबर</p>
                  <p><strong>बीज दर:</strong> 30-35 किलो/एकड़ (देसी), 40-45 किलो/एकड़ (काबुली)</p>
                </div>
              </div>
            </div>

            {/* Soybean */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="p-6">
                <h3 className="text-2xl font-bold text-green-700 mb-3">🔹 सोयाबीन:</h3>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>JS-9560</strong> — 25-28 क्विंटल/एकड़, 90-95 दिन में पकने वाली, यलो मोजेक वायरस प्रतिरोधी। यह किस्म मध्य भारत के लिए उपयुक्त है।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">•</span>
                    <span><strong>MACS-1407</strong> — उच्च प्रोटीन (40-42%), 22-25 क्विंटल/एकड़, फफूंद जनित रोग प्रतिरोधी। यह किस्म महाराष्ट्र और कर्नाटक में अच्छी पैदावार देती है।</span>
                  </li>
                </ul>
                <div className="mt-4 text-sm text-gray-500">
                  <p><strong>बुवाई समय:</strong> जून-जुलाई</p>
                  <p><strong>बीज दर:</strong> 25-30 किलो/एकड़</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Seed Usage Section - Enhanced */}
        <div className="bg-white rounded-lg shadow-2xl p-8 mb-12 transform hover:shadow-3xl transition duration-500">
          <h2 className="text-3xl font-bold text-center mb-8 bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
            बीज उपयोग विधि (Complete Seed Usage Guide)
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Seed Treatment - Enhanced */}
            <div className="bg-gradient-to-br from-green-50 to-blue-50 p-6 rounded-lg border border-green-200 hover:border-green-400 transition duration-300 hover:shadow-md">
              <h3 className="text-xl font-semibold text-green-700 mb-3 flex items-center">
                <span className="bg-green-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3">1</span>
                बीज उपचार (Seed Treatment)
              </h3>
              <p className="text-gray-700 mb-4">
                बीज उपचार से बीज जनित रोगों (जैसे कंडुआ, झुलसा, अंगमारी) से बचाव होता है, बीज का अंकुरण प्रतिशत बढ़ता है और प्रारंभिक अवस्था में पौधों को रोगों व कीटों से सुरक्षा मिलती है। उपचारित बीजों से 15-20% अधिक उपज प्राप्त होती है। रासायनिक उपचार के अलावा जैविक उपचार (नीम का तेल, ट्राइकोडर्मा) भी प्रभावी हैं।
              </p>
              <div className="bg-white p-4 rounded-lg shadow-inner">
                <h4 className="font-medium text-green-600 mb-2">जैविक उपचार विकल्प:</h4>
                <ul className="space-y-1 text-sm">
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">•</span>
                    <span><strong>बीजामृत:</strong> 50 ग्राम गोबर + 50 मिली गोमूत्र + 5 ग्राम चूना + मुट्ठीभर मिट्टी को 20 लीटर पानी में घोलकर बीजों को 30 मिनट तक भिगोएँ। यह बीजों को फफूंदी और बैक्टीरिया से बचाता है।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">•</span>
                    <span><strong>नीम का तेल:</strong> 3 मिली प्रति किलो बीज की दर से नीम का तेल लगाएँ। यह कीटों से सुरक्षा प्रदान करता है और अंकुरण को बढ़ाता है।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">•</span>
                    <span><strong>पंचगव्य:</strong> 1% घोल (10 मिली पंचगव्य प्रति लीटर पानी) में 10 मिनट भिगोएं। यह बीजों की प्रतिरोधक क्षमता बढ़ाता है।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">•</span>
                    <span><strong>ट्राइकोडर्मा:</strong> 5 ग्राम प्रति किलो बीज की दर से ट्राइकोडर्मा विरिडी पाउडर से उपचारित करें। यह मिट्टी जनित रोगों से बचाव करता है।</span>
                  </li>
                </ul>
              </div>
              <div className="mt-4 bg-white p-4 rounded-lg shadow-inner">
                <h4 className="font-medium text-green-600 mb-2">रासायनिक उपचार:</h4>
                <ul className="space-y-1 text-sm">
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">•</span>
                    <span><strong>थायरम:</strong> 2 ग्राम प्रति किलो बीज की दर से उपचारित करें। यह फफूंद जनित रोगों से बचाव करता है।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">•</span>
                    <span><strong>कार्बेन्डाजिम:</strong> 1.5 ग्राम प्रति किलो बीज, विशेष रूप से गेहूं और चावल के लिए उपयोगी।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">•</span>
                    <span><strong>इमिडाक्लोप्रिड:</strong> कीटनाशक के रूप में 2 मिली प्रति किलो बीज, दीमक और अन्य मिट्टी जनित कीटों से बचाव।</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Sowing Method - Enhanced */}
            <div className="bg-gradient-to-br from-green-50 to-blue-50 p-6 rounded-lg border border-green-200 hover:border-green-400 transition duration-300 hover:shadow-md">
              <h3 className="text-xl font-semibold text-green-700 mb-3 flex items-center">
                <span className="bg-green-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3">2</span>
                बुवाई विधि (Sowing Method)
              </h3>
              <p className="text-gray-700 mb-4">
                फसल के अनुसार बुवाई का सही समय चुनें। मौसम और जलवायु परिस्थितियों को ध्यान में रखें। बीज की गहराई और दूरी का विशेष ध्यान रखें। बुवाई की विधि फसल, मिट्टी और जलवायु पर निर्भर करती है। सही बुवाई विधि अपनाने से बीज की बचत होती है और पौधों की वृद्धि अच्छी होती है।
              </p>
              <div className="grid grid-cols-2 gap-2 mb-4">
                <div className="bg-white p-2 rounded shadow-inner">
                  <h4 className="font-medium text-center text-blue-600">बीज गहराई</h4>
                  <ul className="mt-1 text-sm">
                    <li><strong>गेहूं:</strong> 4-5 सेमी (गहरी बुवाई से अंकुरण कम होता है)</li>
                    <li><strong>धान:</strong> 1-2 सेमी (गहरी बुवाई से पौधे कमजोर होते हैं)</li>
                    <li><strong>मक्का:</strong> 3-4 सेमी (उथली बुवाई से पौधे गिर सकते हैं)</li>
                    <li><strong>दलहन:</strong> 3-5 सेमी (मिट्टी के प्रकार के अनुसार)</li>
                    <li><strong>सब्जियाँ:</strong> 0.5-2 सेमी (बीज के आकार के अनुसार)</li>
                  </ul>
                </div>
                <div className="bg-white p-2 rounded shadow-inner">
                  <h4 className="font-medium text-center text-blue-600">पंक्ति दूरी</h4>
                  <ul className="mt-1 text-sm">
                    <li><strong>गेहूं:</strong> 20-22 सेमी (संकीर्ण पंक्तियों से खरपतवार नियंत्रण आसान)</li>
                    <li><strong>धान:</strong> 20×15 सेमी (रोपाई के लिए आदर्श दूरी)</li>
                    <li><strong>मक्का:</strong> 60×20 सेमी (पौधों के बीच पर्याप्त जगह आवश्यक)</li>
                    <li><strong>सरसों:</strong> 30×10 सेमी (फैलाव के लिए जगह आवश्यक)</li>
                    <li><strong>आलू:</strong> 50×20 सेमी (कंद विकास के लिए जगह चाहिए)</li>
                  </ul>
                </div>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-inner">
                <h4 className="font-medium text-blue-600 mb-2">बुवाई की विभिन्न विधियाँ:</h4>
                <ul className="space-y-2 text-sm">
                  <li>
                    <strong>छिड़काव विधि:</strong> छोटे बीजों (जैसे धान, सरसों) के लिए उपयुक्त। बीज समान रूप से नहीं फैलते और अधिक बीज लगता है। यह विधि कम समय लेती है लेकिन बीज की बर्बादी अधिक होती है।
                  </li>
                  <li>
                    <strong>ड्रिल विधि:</strong> सीड ड्रिल से बीज बोना। बीज की गहराई और दूरी नियंत्रित होती है। यह विधि बीज की बचत करती है और अंकुरण अच्छा होता है। गेहूं, चना, मटर आदि के लिए उपयुक्त।
                  </li>
                  <li>
                    <strong>रोपाई विधि:</strong> धान और कुछ सब्जियों के लिए उपयुक्त। नर्सरी में पौध तैयार करके मुख्य खेत में रोपाई की जाती है। इससे पौधों की संख्या नियंत्रित रहती है।
                  </li>
                  <li>
                    <strong>कुंड विधि:</strong> मक्का, कपास, अरहर आदि के लिए उपयुक्त। कुंड बनाकर बीज बोया जाता है। यह विधि सूखा प्रभावित क्षेत्रों के लिए अच्छी है।
                  </li>
                </ul>
              </div>
              <p className="mt-3 text-sm text-gray-600">
                💧 बुवाई के समय मिट्टी में पर्याप्त नमी होनी चाहिए। सूखी मिट्टी में बुवाई न करें। बुवाई के बाद हल्की सिंचाई करें यदि मिट्टी में नमी कम है। बीज अंकुरण के लिए मिट्टी का तापमान भी उपयुक्त होना चाहिए।
              </p>
            </div>

            {/* Soil Preparation - Enhanced */}
            <div className="bg-gradient-to-br from-green-50 to-blue-50 p-6 rounded-lg border border-green-200 hover:border-green-400 transition duration-300 hover:shadow-md">
              <h3 className="text-xl font-semibold text-green-700 mb-3 flex items-center">
                <span className="bg-green-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3">3</span>
                मिट्टी तैयारी (Soil Preparation)
              </h3>
              <p className="text-gray-700 mb-4">
                बुवाई से पहले मिट्टी की उचित तैयारी करें। मिट्टी परीक्षण के आधार पर उर्वरकों का प्रयोग करें। जल निकासी की उचित व्यवस्था करें। अच्छी मिट्टी तैयारी से बीज का अंकुरण बेहतर होता है, पौधों की जड़ें गहराई तक जाती हैं और पोषक तत्वों का अवशोषण बढ़ता है। मिट्टी तैयार करते समय खरपतवार और पिछली फसल के अवशेषों को हटाना आवश्यक है।
              </p>
              <div className="space-y-2">
                <div className="flex items-start bg-white p-3 rounded-lg">
                  <span className="bg-yellow-500 text-white rounded-full w-5 h-5 flex items-center justify-center mr-2 mt-1 flex-shrink-0">1</span>
                  <div>
                    <h4 className="font-medium">मिट्टी की जुताई</h4>
                    <p className="text-sm text-gray-600 mt-1">2-3 बार हल चलाकर मिट्टी को भुरभुरा बनाएं। पहली जुताई मिट्टी पलटने वाले हल से करें ताकि खरपतवार और कीट नष्ट हो जाएं। अंतिम जुताई में कल्टीवेटर या हैरो का उपयोग करें जिससे मिट्टी भुरभुरी हो जाए।</p>
                  </div>
                </div>
                <div className="flex items-start bg-white p-3 rounded-lg">
                  <span className="bg-yellow-500 text-white rounded-full w-5 h-5 flex items-center justify-center mr-2 mt-1 flex-shrink-0">2</span>
                  <div>
                    <h4 className="font-medium">खरपतवार नियंत्रण</h4>
                    <p className="text-sm text-gray-600 mt-1">पिछली फसल के अवशेषों को हटाएं। यदि खरपतवार अधिक हैं तो ग्लाइफोसेट (खरपतवारनाशी) का छिड़काव करें। जुताई के बाद खरपतवारों को जड़ सहित निकाल दें।</p>
                  </div>
                </div>
                <div className="flex items-start bg-white p-3 rounded-lg">
                  <span className="bg-yellow-500 text-white rounded-full w-5 h-5 flex items-center justify-center mr-2 mt-1 flex-shrink-0">3</span>
                  <div>
                    <h4 className="font-medium">मिट्टी परीक्षण</h4>
                    <p className="text-sm text-gray-600 mt-1">मिट्टी परीक्षण के बाद जरूरी सुधार करें। मिट्टी का pH 6.5-7.5 के बीच होना चाहिए। आवश्यकतानुसार चूना या जिप्सम डालें। सूक्ष्म पोषक तत्वों (जिंक, बोरॉन, आयरन आदि) की कमी को पूरा करें।</p>
                  </div>
                </div>
                <div className="flex items-start bg-white p-3 rounded-lg">
                  <span className="bg-yellow-500 text-white rounded-full w-5 h-5 flex items-center justify-center mr-2 mt-1 flex-shrink-0">4</span>
                  <div>
                    <h4 className="font-medium">जैविक खाद</h4>
                    <p className="text-sm text-gray-600 mt-1">बुवाई से 15 दिन पहले 5-10 टन गोबर की खाद डालें। वर्मीकम्पोस्ट (2-3 टन/एकड़) या हरी खाद का भी उपयोग कर सकते हैं। जैविक खाद से मिट्टी की संरचना सुधरती है और सूक्ष्मजीवों की गतिविधि बढ़ती है।</p>
                  </div>
                </div>
                <div className="flex items-start bg-white p-3 rounded-lg">
                  <span className="bg-yellow-500 text-white rounded-full w-5 h-5 flex items-center justify-center mr-2 mt-1 flex-shrink-0">5</span>
                  <div>
                    <h4 className="font-medium">जल निकासी</h4>
                    <p className="text-sm text-gray-600 mt-1">खेत में जल निकासी की उचित व्यवस्था करें। अधिक पानी जमा होने से बीज सड़ सकते हैं। उचित ढलान और नालियाँ बनाएँ। भारी मिट्टी में जल निकासी विशेष रूप से महत्वपूर्ण है।</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Tips - Enhanced */}
          <div className="mt-8 bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-r-lg">
            <h3 className="text-xl font-semibold text-yellow-700 mb-3">विशेष सुझाव:</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <h4 className="font-medium text-gray-800 mb-2">बीज दर निर्धारण:</h4>
                <ul className="space-y-1 text-gray-700">
                  <li className="flex items-start">
                    <span className="text-yellow-600 mr-2">•</span>
                    <span>अंकुरण प्रतिशत के आधार पर बीज दर तय करें। यदि बीज का अंकुरण प्रतिशत 80% है तो 25% अतिरिक्त बीज डालें।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-yellow-600 mr-2">•</span>
                    <span>बड़े आकार के बीजों (मक्का, बीन्स) की दर छोटे बीजों (धान, सरसों) से अधिक होती है।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-yellow-600 mr-2">•</span>
                    <span>खराब मिट्टी या कम उर्वरता वाले खेतों में बीज दर 10-15% अधिक रखें।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-yellow-600 mr-2">•</span>
                    <span>छिड़काव विधि में ड्रिल विधि की तुलना में 20-25% अधिक बीज लगता है।</span>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="font-medium text-gray-800 mb-2">बीज अंकुरण परीक्षण:</h4>
                <ul className="space-y-1 text-gray-700">
                  <li className="flex items-start">
                    <span className="text-yellow-600 mr-2">•</span>
                    <span>100 बीजों को गीले कपड़े में रखकर 5-7 दिन निरीक्षण करें। अंकुरित बीजों की संख्या गिनकर अंकुरण प्रतिशत निकालें।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-yellow-600 mr-2">•</span>
                    <span>75% से कम अंकुरण वाले बीज न खरीदें। अच्छे बीजों में 85-90% अंकुरण क्षमता होनी चाहिए।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-yellow-600 mr-2">•</span>
                    <span>बाजार से बीज खरीदने से पहले अंकुरण परीक्षण अवश्य करें। यदि संभव हो तो बीज उत्पादक के खेत से नमूना लेकर परीक्षण करें।</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-yellow-600 mr-2">•</span>
                    <span>अंकुरण परीक्षण के लिए बीजों को 25-30°C तापमान पर रखें। बहुत अधिक या कम तापमान पर अंकुरण प्रभावित हो सकता है।</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="mt-4 bg-white p-4 rounded-lg">
              <h4 className="font-medium text-gray-800 mb-2">बीज बुवाई के लिए आदर्श परिस्थितियाँ:</h4>
              <ul className="grid grid-cols-2 md:grid-cols-3 gap-2 text-sm">
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">•</span>
                  <span>मिट्टी का तापमान: 25-30°C (अधिकांश फसलों के लिए)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">•</span>
                  <span>मिट्टी में नमी: पर्याप्त (न अधिक गीली न सूखी)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">•</span>
                  <span>हवा की गति: कम (तेज हवा में बुवाई न करें)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">•</span>
                  <span>समय: सुबह या शाम (दोपहर की गर्मी में नहीं)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">•</span>
                  <span>मौसम: साफ (बारिश या तूफान से पहले नहीं)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">•</span>
                  <span>मिट्टी की नमी: बुवाई के बाद हल्की सिंचाई (यदि आवश्यक हो)</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Comprehensive FAQ Section with Detailed Agricultural Information */}
        <div className="bg-white rounded-lg shadow-xl p-8 mb-12">
          <h2 className="text-3xl font-bold text-center mb-8 bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
            अक्सर पूछे जाने वाले प्रश्न (FAQ)
          </h2>

          <div className="space-y-4">
            {[
              {
                question: "1. बीज उपचार क्यों जरूरी है और इसके क्या लाभ हैं?",
                answer: "बीज उपचार फसल उत्पादन की प्रथम और सबसे महत्वपूर्ण प्रक्रिया है जिसके निम्नलिखित लाभ हैं:\n\n• रोग नियंत्रण: बीज जनित रोगों (कंडुआ, झुलसा, अंगमारी) से 80-90% तक सुरक्षा\n• कीट प्रबंधन: मिट्टी में रहने वाले कीटों से प्रारंभिक सुरक्षा\n• अंकुरण दर: उपचारित बीजों में 15-25% बेहतर अंकुरण\n• पौध वृद्धि: स्वस्थ और मजबूत पौधों का विकास\n• उपज वृद्धि: 15-20% तक उपज में वृद्धि\n• लागत प्रभावी: फसल सुरक्षा की अन्य विधियों की तुलना में सस्ता समाधान",
                scientificInfo: "बीज उपचार में प्रयुक्त रसायन (जैसे थायरम, कार्बेन्डाजिम) बीज के आवरण पर सुरक्षात्मक परत बनाते हैं जो रोगजनकों के प्रवेश को रोकते हैं और अंकुरण के समय पौधे की जड़ों की सुरक्षा करते हैं।",
                tips: [
                  "रासायनिक उपचार: थायरम (2g/kg बीज) या कार्बेन्डाजिम (1.5g/kg)",
                  "जैविक उपचार: ट्राइकोडर्मा (5g/kg) + नीम का तेल (3ml/kg) संयोजन",
                  "उपचार तकनीक: बीजों को पहले गीला करें फिर उपचारक लगाएं",
                  "सावधानी: उपचार के बाद बीज को छाया में ही सुखाएं"
                ]
              },
              {
                question: "2. बीज भंडारण की उन्नत तकनीकें और वैज्ञानिक पद्धति",
                answer: "उचित बीज भंडारण के लिए निम्नलिखित बातों का ध्यान रखें:\n\n• तापमान नियंत्रण: 10-15°C आदर्श तापमान (हर 5°C तापमान कम होने पर बीज आयु दुगनी)\n• नमी प्रबंधन: बीज नमी 8-10% से अधिक नहीं (नमी जांच के लिए मोबाइल मीटर उपयोग करें)\n• वायुरोधी भंडारण: पीपी बैग या धातु के कंटेनर में रखें\n• कीट नियंत्रण: नीम पत्तियाँ (100g प्रति किलो बीज) या सिलिका जेल पैकेट्स\n• प्रजाति अनुसार भंडारण अवधि:\n   - धान: 3-4 वर्ष\n   - गेहूँ: 2-3 वर्ष\n   - मक्का: 1-2 वर्ष\n   - दलहन: 2-3 वर्ष",
                scientificInfo: "बीज की श्वसन दर भंडारण अवधि निर्धारित करती है। कम तापमान और नमी पर श्वसन दर कम होती है जिससे बीज लंबे समय तक जीवित रहते हैं। बीजों में 1% नमी कम होने पर भंडारण जीवन दुगना हो जाता है।",
                tips: [
                  "भंडारण से पहले बीजों को 2 दिन धूप में सुखाएं",
                  "कंटेनर के नीचे लकड़ी का कोयला रखें नमी सोखने के लिए",
                  "हर 2 महीने में बीजों का निरीक्षण करें",
                  "संकर बीजों को विशेष सावधानी से भंडारित करें"
                ]
              },
              {
                question: "3. जैविक बीज उपचार की संपूर्ण विधि और वैज्ञानिक आधार",
                answer: "जैविक बीज उपचार की प्रमुख विधियाँ:\n\n1. ट्राइकोडर्मा विधि:\n   - 5 ग्राम ट्राइकोडर्मा प्रति किलो बीज\n   - बीज को हल्का गीला करके पाउडर लगाएं\n\n2. बीजामृत विधि:\n   - 50 ग्राम गोबर + 50 मिली गोमूत्र + 5 ग्राम चूना + मुट्ठीभर मिट्टी\n   - बीजों को 5 मिनट डुबोकर छाया में सुखाएं\n\n3. पंचगव्य विधि:\n   - 1 लीटर पानी में 10 मिली पंचगव्य मिलाएं\n   - बीजों को 30 मिनट भिगोएं\n\n4. नीम आधारित उपचार:\n   - 3 मिली नीम तेल प्रति किलो बीज\n   - बीज के साथ अच्छी तरह मिलाएं",
                scientificInfo: "ट्राइकोडर्मा हर्जियानम कवक रोगजनकों के विरुद्ध प्रतिस्पर्धा करता है और एंजाइम्स छोड़ता है जो रोगजनकों की कोशिका भित्ति को तोड़ते हैं। नीम के यौगिक (अजाडिरेक्टिन) कीटों के हार्मोनल सिस्टम को बाधित करते हैं।",
                tips: [
                  "जैविक उपचार के 24 घंटे के भीतर बुवाई करें",
                  "ट्राइकोडर्मा + नीम तेल संयोजन सर्वोत्तम परिणाम देता है",
                  "बीजामृत बनाते समय ताजा गोबर प्रयोग करें",
                  "जैविक उपचार के बाद बीज को धूप में न सुखाएं"
                ]
              },
              {
                question: "4. बीज गुणवत्ता परीक्षण की वैज्ञानिक विधियाँ और मानक",
                answer: "बीज गुणवत्ता मूल्यांकन के प्रमुख पैरामीटर:\n\n• भौतिक शुद्धता (Minimum 98%):\n   - आकार, रंग, वजन में एकरूपता\n   - अन्य बीजों, मिट्टी, कंकड़ की मात्रा\n\n• अंकुरण क्षमता (Minimum 75%):\n   - 100 बीजों का अंकुरण परीक्षण\n   - 5-7 दिनों तक निरीक्षण\n\n• नमी प्रतिशत (Maximum 12%):\n   - मोबाइल मीटर या ओवन विधि से जाँच\n\n• बीज स्वास्थ्य:\n   - फफूंदी, बैक्टीरिया, कीट क्षति का निरीक्षण\n\n• आनुवंशिक शुद्धता:\n   - प्रमाणित बीजों के लिए विशेष परीक्षण",
                scientificInfo: "अंकुरण परीक्षण के लिए ISTA (International Seed Testing Association) मानकों के अनुसार 25°C तापमान और 90% आर्द्रता आदर्श स्थितियाँ हैं। टेट्राजोलियम टेस्ट (0.1% घोल) से बीज जीवंतता का त्वरित परीक्षण किया जा सकता है।",
                tips: [
                  "अंकुरण परीक्षण के लिए रोलिंग पेपर विधि सर्वोत्तम",
                  "बीज खरीदते समय लेबल पर निम्न जानकारी जाँचें:\n   - अंकुरण प्रतिशत\n   - शुद्धता प्रतिशत\n   - नमी प्रतिशत\n   - पैकिंग तिथि",
                  "बीजों को नमक के घोल (10%) में डालें - खराब बीज ऊपर तैरेंगे"
                ]
              },
              {
                question: "5. हाइब्रिड vs देसी बीज: तुलनात्मक विश्लेषण और चयन मार्गदर्शन",
                answer: "हाइब्रिड और देसी बीजों की तुलना:\n\n• उपज क्षमता:\n   - हाइब्रिड: 30-50% अधिक (किन्तु इनपुट लागत अधिक)\n   - देसी: कम उपज लेकिन स्थिर\n\n• बीज संरक्षण:\n   - हाइब्रिड: अगले वर्ष उपयोग नहीं (F2 पीढ़ी में विशेषताएँ खो जाती हैं)\n   - देसी: पीढ़ी दर पीढ़ी संरक्षित किए जा सकते हैं\n\n• पर्यावरण अनुकूलन:\n   - हाइब्रिड: विशिष्ट परिस्थितियों के लिए विकसित\n   - देसी: स्थानीय परिस्थितियों के अनुकूल\n\n• लागत विश्लेषण:\n   - हाइब्रिड: बीज लागत 3-5 गुना अधिक\n   - देसी: कम लागत पर दीर्घकालिक समाधान",
                scientificInfo: "हाइब्रिड बीजों में हेटेरोसिस (संकर शक्ति) का गुण होता है जिससे उपज बढ़ती है, लेकिन F2 पीढ़ी में यह गुण विभाजित हो जाता है। देसी बीजों में जीन की स्थिरता अधिक होती है जो जैव विविधता संरक्षण में सहायक है।",
                tips: [
                  "हाइब्रिड चुनें यदि:\n   - सिंचाई की पर्याप्त सुविधा हो\n   - उर्वरक/कीटनाशक उपलब्ध हों\n   - बाजार मूल्य अच्छा मिले",
                  "देसी बीज चुनें यदि:\n   - जैविक खेती कर रहे हों\n   - संसाधन सीमित हों\n   - जलवायु अनिश्चित हो",
                  "हाइब्रिड बीजों के लिए रोपण दूरी सख्ती से पालन करें"
                ]
              },
              {
                question: "6. बीज अंकुरण कम होने के वैज्ञानिक कारण और समाधान",
                answer: "अंकुरण कम होने के प्रमुख कारण और उनका निवारण:\n\n1. बीज संबंधी कारण (40% मामले):\n   - समाधान: अंकुरण परीक्षण करके ही बुवाई करें\n\n2. मृदा परिस्थितियाँ (30%):\n   - अधिक नमी: जल निकासी सुधारें\n   - सूखापन: बुवाई से पहले हल्की सिंचाई\n   - कठोर मिट्टी: जुताई गहरी करें\n\n3. बुवाई तकनीक (20%):\n   - अधिक गहराई: बीज आकार के 2-3 गुना गहराई पर बोएं\n   - अनियमित दूरी: सीड ड्रिल का उपयोग करें\n\n4. पर्यावरणीय कारक (10%):\n   - तापमान: पॉलीथीन कवर या मल्चिंग का उपयोग\n   - पाले से बचाव: हल्की सिंचाई सुबह के समय",
                scientificInfo: "बीज अंकुरण के लिए तीन आवश्यक शर्तें: 1) जल (इम्बिबिशन), 2) उपयुक्त तापमान (एंजाइम सक्रियता), 3) ऑक्सीजन (श्वसन)। मिट्टी का तापमान 25-30°C और नमी 50-60% होना आदर्श है। बीज के अंकुरण हार्मोन (जिबरेलिन) का स्राव इन कारकों से प्रभावित होता है।",
                tips: [
                  "अंकुरण बढ़ाने के उन्नत तरीके:\n   - बीज भिगोने के लिए गर्म पानी (50°C) का उपयोग\n   - हाइड्रोजेल का उपयोग नमी संरक्षण के लिए\n   - बायोस्टिमुलेंट्स (सीवीड एक्सट्रैक्ट) का छिड़काव",
                  "आपातकालीन स्थिति में:\n   - 24 घंटे में अंकुरण न होने पर हल्की सिंचाई करें\n   - पपड़ी तोड़ने के लिए हल्की जुताई करें",
                  "देर से बुवाई की स्थिति में:\n   - बीज दर 25% बढ़ाएं\n   - अंकुरण बढ़ाने वाले रसायनों का उपयोग करें"
                ]
              }
            ].map((faq, index) => (
              <div
                key={index}
                className={`border border-gray-200 rounded-lg overflow-hidden transition-all duration-300 ${activeFaq === index ? 'border-purple-500 shadow-lg' : 'hover:border-purple-300'}`}
              >
                <div
                  className={`flex justify-between items-center p-4 cursor-pointer transition-colors duration-300 ${activeFaq === index ? 'bg-gradient-to-r from-purple-50 to-blue-50' : 'hover:bg-gray-50'}`}
                  onClick={() => toggleFaq(index)}
                >
                  <h3 className="text-xl font-semibold text-gray-800">
                    {faq.question}
                  </h3>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`h-6 w-6 text-purple-600 transition-transform duration-300 ${activeFaq === index ? 'transform rotate-180' : ''}`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
                <div
                  className={`overflow-hidden transition-all duration-500 ${activeFaq === index ? 'max-h-[2000px] p-4' : 'max-h-0'}`}
                >
                  <div className="space-y-4">
                    <p className="text-gray-700 whitespace-pre-line">
                      {faq.answer}
                    </p>

                    {faq.scientificInfo && (
                      <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                        <h4 className="font-medium text-blue-700 mb-2 flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                          </svg>
                          वैज्ञानिक आधार:
                        </h4>
                        <p className="text-gray-700">{faq.scientificInfo}</p>
                      </div>
                    )}

                    {faq.tips && (
                      <div className="bg-purple-50 p-3 rounded-lg border border-purple-200">
                        <h4 className="font-medium text-purple-700 mb-2 flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          किसानों के लिए व्यावहारिक सुझाव:
                        </h4>
                        <ul className="space-y-2 pl-5">
                          {faq.tips.map((tip, tipIndex) => (
                            <li key={tipIndex} className="flex items-start text-gray-700">
                              <span className="text-purple-500 font-bold mr-2">→</span>
                              <span className="flex-1">{tip}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeedInformation;